export default __webpack_public_path__ + "static/media/redTicket@3x.be49cb1a.png";